import { z } from "zod";

export const MemberSchema = z.object({
  organization_id: z.string(),
  user_id: z.string(),
  role: z.string(),
  id: z.string(),
  created_at: z.string(),
});

export const OrganizationSchema = z.object({
  id: z.string(),
  name: z.string(),
  slug: z.string().nullish(),
  logo: z.string().nullish(),
  members: z.array(MemberSchema),
  settings: z.unknown().nullish(),
  created_at: z.string(),
  updated_at: z.string(),
});

/**
 * Directory entry returned by `GET /api/organizations/me/members`. Mentions
 * autocomplete is populated from this list; any `@...@...` the composer picks
 * up that isn't present here is demoted to plain text at post time so users
 * can't mention arbitrary email addresses.
 */
export const OrganizationMemberSchema = z.object({
  user_id: z.string(),
  email: z.string(),
  display_name: z.string().nullish(),
});

export type Member = z.infer<typeof MemberSchema>;
export type Organization = z.infer<typeof OrganizationSchema>;
export type OrganizationMember = z.infer<typeof OrganizationMemberSchema>;
